export const KYC_OPTIONS: Array<{ code: string; label: string }> = [
  { code: 'not_started', label: 'No iniciado' },
  { code: 'requested', label: 'Solicitado' },
  { code: 'pending', label: 'Pendiente' },
  { code: 'in_review', label: 'En revisión' },
  { code: 'more_info', label: 'Información adicional' },
  { code: 'approved', label: 'Aprobado' },
  { code: 'rejected', label: 'Rechazado' },
  { code: 'expired', label: 'Vencido' },
  { code: 'suspended', label: 'Suspendido' },
];

export const RISK_OPTIONS: Array<{ code: string; label: string }> = [
  { code: 'low', label: 'Bajo' },
  { code: 'medium', label: 'Medio' },
  { code: 'high', label: 'Alto' },
  { code: 'restricted', label: 'Restringido' },
];

export const RISK_LABEL: Record<string, string> = Object.fromEntries(RISK_OPTIONS.map((r) => [r.code, r.label]));

export const kycTone = (s: string): 'active' | 'warn' | 'broken' | 'muted' =>
  s === 'approved' ? 'active'
    : s === 'rejected' || s === 'expired' || s === 'suspended' ? 'broken'
      : s === 'not_started' ? 'muted'
        : 'warn';

export const riskTone = (r: string): 'active' | 'warn' | 'broken' | 'muted' =>
  r === 'low' ? 'active' : r === 'medium' ? 'warn' : 'broken';

export const KYC_PIPELINE: Array<{ code: string; label: string; match: string[] }> = [
  { code: 'todo', label: 'Por iniciar', match: ['not_started', 'requested'] },
  { code: 'review', label: 'En proceso', match: ['pending', 'in_review', 'more_info'] },
  { code: 'approved', label: 'Aprobados', match: ['approved'] },
  { code: 'blocked', label: 'Bloqueados', match: ['rejected', 'expired', 'suspended'] },
];
